
// 获取微信配置信息的接口
import Axios from 'axios';
import wx from 'weixin-js-sdk'

const isWeixin = () => {
  var ua = navigator.userAgent.toLowerCase();
  return /micromessenger/i.test(ua);
}

let init = false
export default (shareData) => {
  if (init) return

  // if (window.location.hostname == 'localhost' || !isWeixin()) return
  const url = window.location.href.split('#')[0]
  const data = {
    url: url
  }
  if (init) return
  // 获取微信配置信息的接口
  Axios.get('https://website.iceriverbj.com/comon/wxshare.php', { params: data }).then(data => {
    console.log('fx', data);

    wx.config({
      debug: false,
      appId: data.data.appId,
      timestamp: data.data.timestamp,
      nonceStr: data.data.nonceStr,
      signature: data.data.signature,
      jsApiList: [
        'onMenuShareTimeline',
        'onMenuShareAppMessage',
        'getLocation',
        'openLocation'
      ]
    })

    wx.ready(function () {
      // var shareData = {
      //   title: '第四届 微创之光 上海市第一人民医院 国际普胸外科论坛',
      //   desc: '第一轮邀请函',
      //   link: 'https://esign.iceriverbj.com/CollectForms/#/wz1',
      //   imgUrl: 'https://pxsp.iceriverbj.com/WechatIMG102.jpg',
      // };
      console.log('fx', shareData);

      wx.onMenuShareAppMessage(shareData); //分享给好友
      wx.onMenuShareTimeline(shareData); //分享到朋友圈
      wx.onMenuShareQQ(shareData); //分享给手机QQ
      wx.onMenuShareWeibo(shareData); //分享腾讯微博
      wx.onMenuShareQZone(shareData); //分享到QQ空间
      init = true
    });

  }).catch((err) => {
    console.log("🚀 ~ wxshare ~ err:", err)
  })
}
